var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.421875 -0.191406H57.4219L30.7031 26.5273L0.421875 56.8086V-0.191406Z",
    fill: "#8A31FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4969 49.6604L19.8852 35.2394L8.61914 25.544L23.4594 24.2683L29.2714 10.667L35.0834 24.2656L49.9209 25.5413L38.6575 35.2367L42.0458 49.6577L29.2714 42.0034L16.4969 49.6604Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0114 47.5868L20.8587 35.4681L20.9976 34.8773L20.5375 34.4815L11.0733 26.3367L23.545 25.2646L24.1431 25.2132L24.3789 24.6612L29.2715 13.2117L34.1639 24.6586L34.3998 25.2105L34.9978 25.2619L47.4672 26.334L38.0052 34.4788L37.5453 34.8747L37.684 35.4654L40.5315 47.5846L29.7854 41.1456L29.2713 40.8376L28.7573 41.1457L18.0114 47.5868Z",
    stroke: "white",
    strokeOpacity: 0.99,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileIcon);
export default __webpack_public_path__ + "static/media/defaultProfileIcon.33ebc125ff8c047959f36cc9216c629f.svg";
export { ForwardRef as ReactComponent };